<ng-ut-results-calendar
  *ngIf="(store$ | async) as store"
  [filtersConfigs]="filtersConfigs"
  [filtersExtraConfigs]="filtersExtraConfigs"
  [data]="store.monthlyEvents"
  [loading]="store.loading"
  (makeAdvanceSearch)="makeAdvanceSearch($event)">
</ng-ut-results-calendar>
